/**
 * Baixa o relatório de DISPARO de uma campanha (GET /campanha/relatorioDisparo/:id).
 * PDF = resumo (cartões, por chip, por hora, falhas por motivo); CSV = resumo +
 * uma linha por destinatário. Usado na lista de campanhas e na aba Progresso.
 */
import axios from 'axios';
import { sucesso, erro } from '@/helpers/common/api';

export async function baixarRelatorioDisparo(campanhaId, formato = 'pdf') {
  try {
    const resposta = await axios.get(`/campanha/relatorioDisparo/${campanhaId}?formato=${formato}`, {
      responseType: 'blob',
      timeout: 0, // CSV de dezenas de milhares de linhas pode demorar
    });
    const cd = resposta.headers['content-disposition'] || '';
    const m = cd.match(/filename="?([^";]+)"?/i);
    const nome = m ? m[1] : `disparo-campanha-${campanhaId}.${formato}`;

    const url = window.URL.createObjectURL(resposta.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = nome;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    sucesso({ title: `Relatório de disparo (${formato.toUpperCase()}) gerado!` });
    return true;
  } catch (_e) {
    erro({ title: 'Não foi possível gerar o relatório de disparo.' });
    return false;
  }
}

export default baixarRelatorioDisparo;
